import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP } from "./methodology-lookup";
const vehicleFleet = GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.sectors.VEHICLE_FLEET.energySources;
const municipalFacilities = GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.sectors.MUNICIPAL_FACILITIES.energySources;
export const GHG_ADMIN_WELL_TO_TANK_PARENT_BY_SOURCE_ID = {
    [vehicleFleet.DIESEL_WELL_TO_TANK.id]: vehicleFleet.DIESEL.id,
    [vehicleFleet.DIESEL_BIOGENIC_WELL_TO_TANK.id]: vehicleFleet.DIESEL_BIOGENIC.id,
    [vehicleFleet.GASOLINE_WELL_TO_TANK.id]: vehicleFleet.GASOLINE.id,
    [vehicleFleet.BIO_GASOLINE_WELL_TO_TANK.id]: vehicleFleet.BIO_GASOLINE.id,
    [vehicleFleet.NATURAL_GAS_CNG_LNG_WELL_TO_TANK.id]: vehicleFleet.NATURAL_GAS_CNG_LNG.id,
    [vehicleFleet.LPG_WELL_TO_TANK.id]: vehicleFleet.LPG.id,
    [vehicleFleet.ELECTRICITY_WELL_TO_TANK.id]: vehicleFleet.ELECTRICITY.id,
    [municipalFacilities.NATURAL_GAS_WELL_TO_TANK.id]: municipalFacilities.NATURAL_GAS.id,
    [municipalFacilities.HEATING_OIL_WELL_TO_TANK.id]: municipalFacilities.HEATING_OIL.id,
    [municipalFacilities.HARD_COAL_WELL_TO_TANK.id]: municipalFacilities.HARD_COAL.id,
    [municipalFacilities.LIGNITE_WELL_TO_TANK.id]: municipalFacilities.LIGNITE.id,
    [municipalFacilities.BIOGAS_WELL_TO_TANK.id]: municipalFacilities.BIOGAS.id,
    [municipalFacilities.BIOMASS_WELL_TO_TANK.id]: municipalFacilities.BIOMASS.id,
    [municipalFacilities.HEATING_ELECTRICITY_WELL_TO_TANK.id]: municipalFacilities.HEATING_ELECTRICITY.id,
};
